import React, { Component } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import moment from 'moment'
import queryString from 'query-string'
import CommonModal from '../Modals/common'
import './styles.scss'
import history from '../history'
import { weekDaysShort, celsiusToFahrenheit, defaultSchedule, coversion, customSchedule, Settings } from '../../constants/common'

const { home1, home2, away, sleep } = defaultSchedule

class SetTemperatureSchedule extends Component {
  constructor() {
    super()
    this.state = {
      roomTitle: 'Set Temperature Schedule',
      dayOfWeek: 1,
      showSavedModal: false,
      room: {},
      roomId: 0,
      finalSchedules: [],
      timeTemperature: _.cloneDeep(customSchedule) // To avoid bindable behaviour deepclone is used
    }
    this.temperature = Settings.MinMax()
    this.celsiusToFahrenheit = celsiusToFahrenheit
    this.coversion = coversion // Return user setting for Celcius or Fahrenheit
    this.closeModal = this.closeModal.bind(this)
    this.setScheduleCall = this.setScheduleCall.bind(this)
    this.editSchedule = this.editSchedule.bind(this)
  }

  componentWillMount() {
    const { fetchRooms, location } = this.props
    fetchRooms() // API to get room
    // check if user comes after the registration then no roomId in query string
    const room = queryString.parse(location.search)
    const roomTitle = !room.roomId ? 'Set Temperature Schedule' : ''

    // Pick room Id from local storage either set from register cozy or from home edit room drop down 
    const roomId = localStorage.getItem('room') ? localStorage.getItem('room') : 0
    this.setState({ roomId: parseInt(roomId, 10), roomTitle: roomTitle }, () => {
      const dayOfWeek = localStorage.getItem('dayOfWeek') ? localStorage.getItem('dayOfWeek') : 1
      this.setState({ dayOfWeek: parseInt(dayOfWeek, 10) })
    })
  }
  // API response
  componentWillReceiveProps(np) {
    const { setScheduleSuccess, rooms, setSchedule } = np
    if (setScheduleSuccess) {
      // Call setNickName api and will always pass first element from the sliced data, till it gets empty
      const data = _.cloneDeep(this.state.finalSchedules)
      data.splice(0, 1)
      this.setState({ finalSchedules: data }, () => {
        if (data.length === 0) {
          // close modal on api success
          this.setState({ showSavedModal: true })
        } else {
          const room = _.first(this.state.finalSchedules)
          setSchedule(room)
        }
      })
    }
    if (rooms && rooms !== this.props.rooms) {
      this.setRoomSchedules(rooms)
    }
  }

  setRoomSchedules(rooms) {
   // Set data for single room filtering using room id and convert fahrenheit to celsius or vice-versa
    const room = _.cloneDeep(rooms.filter(room => room.id === this.state.roomId)[0] ? rooms.filter(room => room.id === this.state.roomId)[0] : rooms[0])
    room.currentTemp = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.currentTemp) : room.currentTemp
    room.home = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.home) : Math.round(room.home)
    room.setpoint = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.setpoint) : Math.round(room.setpoint)
    room.sleep = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.sleep) : Math.round(room.sleep)
    this.setState({ room }, () => {
      this.prepareTimeTemperature()
    })
  }
  // Set current selected schedule for week day
  prepareTimeTemperature() {
    let { timeTemperature, room } = this.state
    const currentSchedule = room.schedules.filter(schedule => schedule.dayOfWeek === this.state.dayOfWeek)
    // if (_.size(currentSchedule)) {
    _.forEach(timeTemperature, (schdule, index) => {
      if (index === 0) { // home1
        timeTemperature[index].value = _.get(currentSchedule, '[0].home1', home1)
        timeTemperature[index].valueTo = _.get(currentSchedule, '[0].away', away)
        timeTemperature[index].temp = _.get(room, 'home', this.temperature.RED)
      } else if (index === 1) { // away
        timeTemperature[index].value = _.get(currentSchedule, '[0].away', away)
        timeTemperature[index].valueTo = _.get(currentSchedule, '[0].home2', home2)
        timeTemperature[index].temp = _.get(room, 'away', this.temperature.AWAY)
      } else if (index === 2) { // home2
        timeTemperature[index].value = _.get(currentSchedule, '[0].home2', home2)
        timeTemperature[index].valueTo = _.get(currentSchedule, '[0].sleep', sleep)
        timeTemperature[index].temp = _.get(room, 'home', this.temperature.RED)
      } else if (index === 3) { // sleep
        timeTemperature[index].value = _.get(currentSchedule, '[0].sleep', sleep)
        timeTemperature[index].valueTo = this.nextDayHome(room)
        timeTemperature[index].temp = _.get(room, 'sleep', this.temperature.SLEEP)
      }
    })
    this.setState(timeTemperature)
  }

  nextDayHome(room) {
    // set next to Monday is current day is Sunday
    const day = this.state.dayOfWeek === 7 ? 1 : this.state.dayOfWeek + 1
    // pick next day schedule from room
    const nextDaySchedule = room.schedules.filter(schedule => schedule.dayOfWeek === day)
    return _.size(nextDaySchedule) ? _.get(nextDaySchedule, '[0].home1') : home1
  }
  // API call to save temperature & schedule
  // Imp: This save will work after signup call and also for other if any room doesn't has schedule.
  onSaveClick() {
    const { setSchedule, rooms } = this.props
    const obj = defaultSchedule
    let newSchedules = []
    // Set day of week which are not present inside the rooms schedules
    for (let room of rooms) {
      let days = []
      room.schedules.map(s => days.push(s.dayOfWeek)) // push day of week in a day array to process on all rooms
      days = new Set(days)
      for(let i = 1; i <= 7; i++) {
        // !days.has(i) filter out the existing days and will push only non exists schedules
        if(!days.has(i)) newSchedules.push({ ...obj, dayOfWeek: i, id: room.id })
      }
    }
    // Finds the id of the single room having schedules and copy that schedules to the other rooms
    const theRoom = rooms.find(room => room.schedules.length)
    const currentSchedules = rooms.reduce((roomSchedules, { id, schedules }) => {
      // Will copy only when schedule array will be 0 and room id is not equal to id where this schedule exists. 
      if(theRoom && id !== _.get(theRoom, 'id', 0) && _.size(schedules) === 0)
        roomSchedules.push(...theRoom.schedules.map(schedule => ({ id, ...schedule })))
      return roomSchedules
    }, [])
    // Union both arrays by dayOfWeek and give the priority to the elements from the first array
    const finalSchedules = _.unionBy(currentSchedules, newSchedules, o => `${o.id}-${o.dayOfWeek}`)
    // _.size(newSchedules) > 0 means no need to copy schedules on other rooms if user is not coming from signup
    this.setState({ finalSchedules: _.size(newSchedules) > 0 ? finalSchedules : newSchedules }, () => {
      // Api call to the set schedule, passing first element to the api
      if (_.first(this.state.finalSchedules)) {
        setSchedule(_.first(this.state.finalSchedules))
      } else { // Move to home page after saving all the temperature and schedule data as applicable ie on all rooms after signup
        this.setScheduleCall()
      }
    })
  }

  setScheduleCall() {
    history.push('/home')
  }
  // Will be called from child modal component
  closeModal() {
    this.setState({ showSavedModal: false })
    this.setScheduleCall()
  }
  
 editSchedule(schedule, index) {
    // Redirect to edit schedule page
    const type = schedule.label
    const fromTime = schedule.value
    const toTime = schedule.valueTo
    const roomId = this.state.room.id
    // index === 2 means home2 check
    const typeLower = index === 2 ? String(type).toLowerCase()+index : String(type).toLowerCase()
    this.props.history.push(
      `/edit-schedule?type=${typeLower}&from=${fromTime}&to=${toTime}&roomId=${roomId}&dayOfWeek=${this.state.dayOfWeek}`
    )
  }

  editTemperature(index) {
    const temp = this.state.timeTemperature
    const { location } = this.props
    const room = queryString.parse(location.search)

    if (index === 1) { // Away temperature is not editable
      return 
    }
    // Redirect to edit temperature page
    if (room.roomId) {
      const currentRoomId = this.state.room.id // this should picked from state becuase drop down selecting it
      this.props.history.push(`/edit-temp?home=${_.get(temp, '[0].temp', this.temperature.RED)}&sleep=${_.get(temp, '[3].temp', this.temperature.MIN)}&roomId=${currentRoomId}`)
    } else { // roomId = all means user come from signup form, so all will be copied to all available rooms
      this.props.history.push(`/edit-temp?home=${_.get(temp, '[0].temp', this.temperature.RED)}&sleep=${_.get(temp, '[3].temp', this.temperature.MIN)}&roomId=all`)
    }
  }

  changeRoom(e) {
    const { rooms } = this.props
    this.setState({ roomId: parseInt(e.target.value, 10) }, () => {
      localStorage.setItem('room', this.state.roomId)
      this.setRoomSchedules(rooms)
    })
  }

  onChangeDayOfWeek(i) {
    this.setState({ dayOfWeek: i + 1 }, () => {
      localStorage.setItem('dayOfWeek', this.state.dayOfWeek)
      this.prepareTimeTemperature()
    })
  }

  render() {
    const { roomTitle, roomId, dayOfWeek, timeTemperature, room } = this.state
    return (
      <div>
        <main id="SetTemperatureSchedule">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    {roomTitle !== 'Set Temperature Schedule' ? (
                      <div className="close">
                        <a onClick={() => history.goBack()}>
                          <img alt="" src="/img/close-icon.png" />
                        </a>
                      </div>
                    ) : (
                      ''
                    )}
                    <h3 className="secondary-title d-block d-md-none">{roomTitle}</h3>
                    <div className="header-img-box d-none d-md-block">
                      <Link to="/home">
                        <img src="/img/yellow-logo.png" alt="" />
                      </Link>
                      <div className="logo-title">Operated by Radiator Labs</div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="container-inner">
              <h3 className="secondary-title d-none d-md-block text-center">{roomTitle}</h3>
              {roomTitle !== 'Set Temperature Schedule' &&
                <form action="" className="select-cat-box">
                  <select name="timepass" className="custom-select" value={roomId} onChange={e => this.changeRoom(e)}>
                    {this.props.rooms &&
                      this.props.rooms.map((room, i) => {
                        return (
                          <option key={i} value={room.id}>
                            {_.get(room, 'nickname') || _.get(room, 'name')}
                          </option>
                        )
                      })}
                  </select>
                </form>
              }
              <div className="calendar">
                <ul className="weekdays">
                  {weekDaysShort.map((week, i) => {
                    return (
                      <li key={i} onClick={() => this.onChangeDayOfWeek(i)} className={dayOfWeek === i + 1 ? 'active' : ''}>
                        {week}
                      </li>
                    )
                  })}
                </ul>
                <ul className="list-group list-group-flush">
                  {timeTemperature.map((schedule, i) => {
                    return (
                      <li key={'li' + i} className="list-group-item d-flex align-items-center justify-content-between">
                        <div onClick={() => this.editSchedule(schedule, i)}>
                          <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                            <img alt="" src={schedule.src} />
                            <h5>{schedule.label}</h5>
                          </div>
                          <div className="time-box">
                            <time>{moment(schedule.value, 'HH:mm').format('hh:mm a')}</time>
                            <img className={schedule.label === 'Sleep' ? 'arrow_right_icon' : 'display-none'}  alt="" src="img/arrow_right_icon_small.svg" />
                            <small className={schedule.label === 'Sleep' ? 'hide' : ''}> - </small>
                            <time className={schedule.label === 'Sleep' ? 'hide' : ''}>{moment(schedule.valueTo, 'HH:mm').format('hh:mm a')}</time>
                            <img className={schedule.label === 'Sleep' ? 'hide' : 'arrow_right_icon'}  alt="" src="img/arrow_right_icon_small.svg" />
                          </div>
                        </div>
                        <div
                          className={schedule.label === 'Away' ? 'temperature-box d-flex' : 'temperature-box d-flex cursor'}
                          onClick={() => this.editTemperature(i)}
                        >
                          <img
                            className="degree-icon"
                            alt=""
                            src={schedule.temp < this.temperature.BLUE ? 'img/noun_blue_icon.svg' : schedule.temp < this.temperature.ORANGE ? 'img/noun_icon.svg' : 'img/noun_red_icon.svg'}
                          />
                          <span className={schedule.temp < this.temperature.BLUE ? 'blue' : schedule.temp < this.temperature.ORANGE ? 'orange' : 'red'}>
                            {schedule.temp}
                            <small className={schedule.temp < this.temperature.BLUE ? 'blue' : schedule.temp < this.temperature.ORANGE ? 'orange' : 'red'}>°{this.coversion()}</small>
                          </span>
                          <img
                            className={schedule.label === 'Away' ? 'arrow_right_icon hide' : 'arrow_right_icon'}
                            alt=""
                            src="img/arrow_right_icon.svg"
                          />
                        </div>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
            <footer>
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="footer-inner">
                      {
                        roomTitle !== 'Set Temperature Schedule' ? (
                        <Link to={`/copy-schedule?dayOfWeek=${dayOfWeek}&roomId=${!room ? 'all' : _.get(room, 'id')}`}>
                          <button type="button" className="btn btn-secondary btn-lg btn-block">
                            Copy this schedule to other days
                          </button>
                        </Link>
                      ) : (
                        <Link to={`/copy-schedule?dayOfWeek=${dayOfWeek}`}>
                          <button type="button" className="btn btn-secondary btn-lg btn-block">
                            Copy this schedule to other days
                          </button>
                        </Link>
                      )}
                      <button disabled={!room.home} type="button" className="btn btn-primary btn-lg btn-block" onClick={() => this.onSaveClick()}>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
          <CommonModal
            key="setTemperature"
            modalType="setTemperature"
            open={this.state.showSavedModal}
            {...this.props}
            closeModal={this.closeModal}
          />
        </main>
      </div>
    )
  }
}
export default SetTemperatureSchedule



// WEBPACK FOOTER //
// ./src/views/SetTemperatureSchedule/component.js